import { render, staticRenderFns } from "./Consents.vue?vue&type=template&id=50a3baf4"
import script from "./Consents.vue?vue&type=script&lang=js"
export * from "./Consents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports